import { SensorConversions } from "../conversionFunctions/sensorConversions.js";
import { OUTPUT_OPERATING_MODE_RANGE, OutputOperatingMode } from "../outputOperatingMode.js";
import { SensorElementConfig } from "./types.js";

/**
 * How a device output is currently being driven — an {@link OutputOperatingMode} enum member, not a
 * quantity.
 *
 * This is the first categorical sensor element with its own unit category rather than one smuggled
 * through `dimensionless` via the `code` kind. It is not built with
 * `makeSimpleDigitalSensorElement` because it is the only member of `outputOperatingMode`, and the
 * range is bounded by the enum rather than by a general "code" convention, so an out-of-range value is
 * caught.
 *
 * The conversion is `unity`: a mode identifier has nothing to convert, and unit conversion of it would
 * be meaningless — which is why the unit category permits only `dimensionless`.
 */
export const outputOperatingModeElementConfig: SensorElementConfig<
    Record<string, never>,
    typeof SensorConversions.unity
> = {
    legalConvertedRange: OUTPUT_OPERATING_MODE_RANGE,
    conversionKey: "unity",
    parameterConfigs: {},
    buildConversionParams: () => ({}) as Record<string, never>,
    decodedUnits: "dimensionless",
    convertedUnits: "dimensionless",
    unitCategory: "outputOperatingMode",
    testCases: [
        { parameters: {}, decodedValue: OutputOperatingMode.SCHEDULE, convertedValue: OutputOperatingMode.SCHEDULE },
        { parameters: {}, decodedValue: OutputOperatingMode.MANUAL, convertedValue: OutputOperatingMode.MANUAL },
        {
            parameters: {},
            decodedValue: OutputOperatingMode.DUTY_CYCLE_AUTOMATION,
            convertedValue: OutputOperatingMode.DUTY_CYCLE_AUTOMATION,
        },
    ],
};
